import { useOnlineStatus } from '../hooks/useOnlineStatus';

export function OfflineBanner() {
  const online = useOnlineStatus();

  if (online) return null;

  return (
    <div
      className="bg-warning-bg border-b border-warning-border px-4 py-2 text-center text-sm text-warning-fg"
      role="alert"
    >
      You're offline. Some features may not work until you reconnect.
    </div>
  );
}
